export const INITIAL_ROW_SELECTION_MODEL = {
  type: 'include',
  ids: new Set(),
};